var map = {
	"./paymentmethod-amex.svg": "dBje",
	"./paymentmethod-bank.svg": "Q2pP",
	"./paymentmethod-discover.svg": "Br4k",
	"./paymentmethod-mastercard.svg": "/MH6",
	"./paymentmethod-visa.svg": "h8nL"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YLPz";